import { combineReducers } from "@reduxjs/toolkit"
import BannerReducer from "./BannerReducer"
import BrandReducer from "./BrandReducer"
import CartListReducer from "./CartListReducer"
import CategoryList from './CategoryReducer'
import FlagshipStores from "./FlagshipStoreReducer"
import forgetPassword from './ForgetPasswordReducer'
import loginReducer from "./loginReducer"
import UserOtpReducer from "./otpMessageReducer"
import ProcessToCheckoutReducer from "./ProcessToCheckoutReducer"
import productList from "./ProductListReducer"
import ResetPassword from "./ResetPasswordReducer"
import UserInfoReducer from "./userInfoReducer"
import CollectionListReducer from "./CollectionListReducer"
import CustomerAddressReducer from "./CustomerAddressReducer"
import CountryListReducer from "./CountryListReducer"
import CustomerProfileReducer from "./CustomerProfileReducer"
import CustomerOrderReducer from "./CustomerOrderReducer"
import CustomerVouchersApplyReducer from "./CustomerVouchersApplyReducer"
import CustomerCartReducer from "./CustomerCartReducer"
import CustomerWishListReducer from "./CustomerWishListReducer"
import CustomerCollectionReducer from "./CustomerCollectionReducer"
import SearchSuggestReducer from "./SearchSuggestReducer"
import SearchResultsReducer from "./SearchResultsReducer"



const rootReducer = combineReducers({
	userInfo: UserInfoReducer,
	userOtpMessage: UserOtpReducer,
	loginInfo: loginReducer,
	hero_banners: BannerReducer,
	flagship_stores: FlagshipStores,
	brands: BrandReducer,
	forget_Password: forgetPassword,
	reset_password: ResetPassword,
	productList: productList,
	categoryList: CategoryList,
	cartList: CartListReducer,
	ProcessToCheckout: ProcessToCheckoutReducer,
	collectionList:CollectionListReducer,
	customerAddress: CustomerAddressReducer,
	countryList:CountryListReducer,
	customerProfile:CustomerProfileReducer,
	customerOrder:CustomerOrderReducer,
	customerVouchers:CustomerVouchersApplyReducer,
	customerCart: CustomerCartReducer,
	customerWishlist: CustomerWishListReducer,
	customerCollection: CustomerCollectionReducer,
	searchSuggest: SearchSuggestReducer,
	searchResults: SearchResultsReducer,

})

export default rootReducer
